/**
 * Shared height for every control that sits in a page toolbar — view toggles,
 * filter buttons, selects, search fields, primary CTAs.
 *
 * Without a single token these drift apart: MUI's own sizes differ per variant
 * (`small` buttons are 30.75px, `medium` 36.5px), several call sites override
 * the vertical padding by hand (`py: 0.2`), and `CheckboxMultiSelect` sets its
 * own 40px floor. 40px matches the select and the default `size='small'` text
 * field, so it is the value the rest lines up to.
 */
export const TOOLBAR_CONTROL_HEIGHT = 40;

/** Spread into an `sx` prop: `sx={{ ...toolbarControlSx, ...rest }}`. */
export const toolbarControlSx = {
  height: TOOLBAR_CONTROL_HEIGHT,
  minHeight: TOOLBAR_CONTROL_HEIGHT,
  boxSizing: 'border-box' as const,
};
